module.exports = __webpack_public_path__ + "static/media/TipoDoc2.22f1d346.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadTipoDoc/TipoDoc2.png
// module id = 2191
// module chunks = 0